import PropTypes from 'prop-types';
import React from 'react'
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom'
import TimerMixin from 'react-timer-mixin';

import { verifyEmailAddress } from '~/actions/verification'



export default createReactClass({

	propTypes: {
		dispatch: PropTypes.func.isRequired,
		history: PropTypes.object.isRequired,
		verification: PropTypes.object,
	},
	mixins: [TimerMixin],

	getInitialState: function() {
		return {
			verified: false
		}
	},

	componentWillMount: function() {

		if( !('key' in this.props.routeParams) ) return false;
		if( this.props.verification.fetching.email ) return false;

		this.props.dispatch( verifyEmailAddress(this.props.routeParams.key) )

	},

	componentDidUpdate: function(prevProps, prevState) {

		if( !prevProps.verification.email && !!this.props.verification.email ) {
			this.setState({
				verified: true
			})
			this.setTimeout(() => { 
				this.props.history.push('/')
			}, 2000);

		}

	},

	render: function() {

		return (

			this.state.verified
				? <span>Verifying your email address...</span>
				: <span>Verified! <Link to='/'>Redirecting you...</Link></span>

		)

	}

})



// WEBPACK FOOTER //
// ./src/js/views/Verification/index.jsx